(function(){
  function init(root){
    (root || document).querySelectorAll('[data-fumiko-bundle-selector]').forEach(function(selector){
      if(selector.dataset.bound === 'true') return;
      selector.dataset.bound = 'true';

      var scope = selector.closest('.product__info-container') || selector.closest('product-info') || document;
      var form =
        scope.querySelector('product-form form[data-type="add-to-cart-form"]') ||
        scope.querySelector('form[action*="/cart/add"]');
      var variantInput = form ? form.querySelector('input[name="id"]') : null;
      var quantityInput =
        scope.querySelector('input[name="quantity"]') ||
        (form ? document.querySelector('input[name="quantity"][form="' + form.id + '"]') : null);
      var options = selector.querySelectorAll('[data-variant-id]');

      function selectOption(btn){
        var variantId = btn.getAttribute('data-variant-id');
        selector.dataset.selectedVariantId = variantId || '';

        // Keep the hidden product-form variant in sync, but do not fire Dawn's
        // variant-change lifecycle because the 2-pack is a separate bundle product.
        if(variantInput && variantId){
          variantInput.disabled = false;
          variantInput.value = variantId;
        }

        if(quantityInput){
          quantityInput.value = 1;
        }

        options.forEach(function(option){
          var active = option === btn;
          option.classList.toggle('is-active', active);
          option.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      }

      options.forEach(function(btn){
        btn.addEventListener('click',function(){
          selectOption(btn);
        });
      });

      // Capture phase runs before Dawn product-form builds FormData.
      // This guarantees the selected bundle variant is what Shopify receives.
      if(form){
        form.addEventListener('submit',function(){
          var selectedVariantId = selector.dataset.selectedVariantId;
          if(variantInput && selectedVariantId){
            variantInput.disabled = false;
            variantInput.value = selectedVariantId;
          }
          if(quantityInput){
            quantityInput.value = 1;
          }
        },true);
      }

      if(options.length) selectOption(options[0]);
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded',function(){ init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load',function(e){ init(e.target); });
})();